module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-4-photo-10-317b46f2912f9085d6d7b70271816ca7.webp";